import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tooltip"
}
const _hoisted_2 = {
  key: 0,
  class: "text-xl material-icons"
}
const _hoisted_3 = {
  key: 1,
  class: "flex items-center max-w-full px-2 py-1 border border-gray-300 rounded-md shadow-inner w-max"
}
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "flex ml-2 border-l" }
const _hoisted_6 = { class: "h-full -mb-0.5 tooltip" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-base material-icons-outlined" }, " content_copy ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _directive_clipboard = _resolveDirective("clipboard")!

  return (_ctx.iconOnly)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives((_openBlock(), _createBlock(_component_Btn, {
          tooltip: _ctx.showFeedback ? '' : _ctx.tooltip,
          class: "copy-btn",
          title: _ctx.title || _ctx.$t('misc.copy'),
          outline: true,
          size: 'sm',
          variant: 'icon'
        }, {
          default: _withCtx(() => [
            (!_ctx.$slots.default)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, " share "))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 8, ["tooltip", "title"])), [
          [_directive_clipboard, _ctx.value, "copy"],
          [_directive_clipboard, _ctx.onCopy, "success"]
        ]),
        (_ctx.showFeedback)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["tooltip-text tooltip-bottom", { 'tooltip-text-force': _ctx.showFeedback }])
            }, _toDisplayString(_ctx.confirmationMessage || _ctx.$t("misc.copied")), 3))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _withDirectives((_openBlock(), _createElementBlock("div", {
          title: _ctx.$t('misc.copy'),
          class: "cursor-pointer hover:bg-light px-1 py-0.5 rounded-sm overflow-x-auto"
        }, [
          _createTextVNode(_toDisplayString(_ctx.value), 1)
        ], 8, _hoisted_4)), [
          [_directive_clipboard, _ctx.value, "copy"],
          [_directive_clipboard, _ctx.onCopy, "success"]
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _withDirectives((_openBlock(), _createBlock(_component_Btn, {
              title: _ctx.$t('misc.copy'),
              class: "h-full px-2 py-2 -mt-1 -mb-1 -mr-2 rounded-tr-md rounded-br-md",
              variant: 'transparent'
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["title"])), [
              [_directive_clipboard, _ctx.value, "copy"],
              [_directive_clipboard, _ctx.onCopy, "success"]
            ]),
            (_ctx.showFeedback)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(["tooltip-text tooltip-bottom", { 'tooltip-text-force': _ctx.showFeedback }])
                }, _toDisplayString(_ctx.$t("misc.copied")), 3))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
}